import { useContext, useEffect } from 'react';
import { useIntl } from 'react-intl';
import { AppContext } from '../../AppContext';
import binIcon from '@luna-protocol/core/src/assets/binIcon.png';
import messages from './Accessories.message';
import { TotalsProps } from '../../AppContext.tsx';

import './Accessories.scss';

const AccessoriesList = () => {
  const { formatMessage } = useIntl();
  const { deal, setDeal, totals, setTotals, OEMType } = useContext(AppContext);
  const disclaimer =
    OEMType === 'ktm' ? messages.motorcyclesFinanceableDisclaimer : messages.boatsFinanceableDisclaimer;

  useEffect(() => {
    const sum = deal?.accessories?.reduce((acc, curr) => {
      return acc + (!curr.is_financeable ? Number(curr.price) : 0);
    }, 0);
    setTotals({ ...totals, base_accessories: sum } as TotalsProps);
  }, []);

  const handleChange = (index: number, key: string, value: string | number | boolean) => {
    if (deal === undefined) return;
    const targetedAccessory = deal?.accessories[index];

    setDeal({
      ...deal,
      accessories: [
        ...deal.accessories.map(accessory => {
          if (accessory === targetedAccessory) {
            if (key === 'is_financeable') {
              return {
                ...accessory,
                is_financeable: !accessory.is_financeable,
              };
            }

            return {
              ...accessory,
              [key]: value,
            };
          }

          return accessory;
        }),
      ],
    });
  };

  const handleRemoveAccessory = (index: number) => {
    if (deal === undefined) return;

    const targetedAccessory = deal?.accessories[index];

    setDeal({
      ...deal,
      accessories: [...deal.accessories.filter(accessory => accessory !== targetedAccessory)],
    });
  };

  return (
    <>
      <table className="accessories-list">
        {deal && deal.accessories?.length > 0 ? (
          <>
            <thead>
              <tr>
                <th>{formatMessage(messages.accessoriesLabel)}</th>
                <th>{OEMType === 'ktm' ? formatMessage(messages.msrpLabel) : formatMessage(messages.priceLabel)}</th>
                <th className="checkbox-title">{formatMessage(messages.financeableLabel)}</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {deal.accessories?.map((accessory, index) => {
                return (
                  <tr key={index} className="accessories-list--row">
                    <td className="text-input-container accessories-input--name">
                      <input
                        className="text-input"
                        type="text"
                        name={accessory.name}
                        value={accessory.name}
                        onChange={e => handleChange(index, 'name', e.target.value)}
                        data-testid={`accessory-input--name-${index}`}
                      />
                    </td>
                    <td className="accessories-input--price">
                      <div className="text-input-container">
                        <span className="currency-prefix">$</span>
                        <input
                          className="text-input currency"
                          type="currency"
                          name="accessory-price"
                          placeholder="0"
                          value={accessory.price == 0 ? undefined : accessory.price?.toFixed(2)}
                          onChange={e => handleChange(index, 'price', Number(e.target.value))}
                          data-testid={`accessory-input--price-${index}`}
                        />
                      </div>
                    </td>
                    <td className="accessories-checkbox--container">
                      <input
                        className="accessories-checkbox--input"
                        type="checkbox"
                        name="is_financeable"
                        checked={accessory.is_financeable}
                        onChange={e => handleChange(index, 'is_financeable', e.target.value)}
                        data-testid={`is_financeable-checkbox-${index}`}
                      />
                    </td>
                    <td className="accessories-delete-row">
                      <button
                        className="delete-row--btn"
                        type="button"
                        onClick={() => handleRemoveAccessory(index)}
                        data-testid={`delete-row-${index}`}>
                        <img className="delete-row--icon" src={binIcon} />
                      </button>
                    </td>
                  </tr>
                );
              })}
              <tr>
                <td colSpan={100} className="accessories-disclaimer">
                  <sub>
                    <sup>**</sup>
                    {formatMessage(disclaimer)}
                  </sub>
                </td>
              </tr>
            </tbody>
          </>
        ) : (
          <tbody>
            <tr>
              <td>
                <span className="no-items">{formatMessage(messages.noItems)}</span>
              </td>
            </tr>
          </tbody>
        )}
      </table>
    </>
  );
};

export default AccessoriesList;
